
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    mailingObjects: {
        showMode: "none",
        showOverlay: false,
        currentObj: {},
        mailingPreview: {},
        showMailingBox: false
    },
}
const CropReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.MAILINGTOOL_UPDATE_MAILINGOBJECTS_START:
            return { loading: true };
        case actionTypes.MAILINGTOOL_UPDATE_MAILINGOBJECTS_SUCCESS:
            return { loading: false, mailingObjects: { ...state.mailingObjects, ...action.payload } }
        case actionTypes.MAILINGTOOL_UPDATE_MAILINGOBJECTS_FAIL:
            return { loading: false };
        case actionTypes.MAILINGTOOL_SET_LOADING:
            return { ...state, loading: action.payload };
        case actionTypes.MAILINGTOOL_SET_INIT_MAILINGOBJECTS:
            return { ...INITIAL_STATE };
        default:
            return state;
    }
}

export default CropReducer;